import React, { useEffect, useMemo, useCallback, useState } from 'react';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { usePrompt } from '../common/hooks/usePrompt';
import RegisterForm from './forms/RegisterForm';
import RouterPaths from '../constants/RouterPaths';
import { clearCompanyDetails } from './RegisterActions';

function RegisterPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const { companyDetails, companyNumber, officialCompanyName, isAuthenticated } = useSelector(
    (state) => ({
      companyDetails: state.register.get('companyDetails'),
      companyNumber: state.register.get('companyNumber'),
      officialCompanyName: state.register.get('officialCompanyName'),
      isAuthenticated: state.auth.get('isAuthenticated'),
    }),
  );

  useEffect(() => {
    if (isAuthenticated) {
      navigate(RouterPaths.DASHBOARD);
    }
  }, [isAuthenticated, navigate]);

  const cleanupCompanyDetails = useCallback(() => dispatch(clearCompanyDetails()), [dispatch]);

  useEffect(() => cleanupCompanyDetails, [cleanupCompanyDetails]);

  const initialValues = useMemo(
    () => ({
      organizationRole: 'INDEPENDENT_DEALER', // Default since we removed dealer type selection
      vatNumber: companyDetails?.vatNumber || '',
      officialCompanyName: officialCompanyName || '',
      tradeName: companyDetails?.tradeName || '',
      buyerNextGearId: companyDetails?.buyerNextGearId || '',
      companyRegisterNumber: companyNumber || '',
      postalCode: companyDetails?.postalCode?.value
        ? {
            value: companyDetails?.postalCode?.value,
            label: companyDetails?.postalCode?.label,
          }
        : '',
      address: companyDetails?.address || '',
      address2: companyDetails?.address2 || '',
      city: companyDetails?.city || '',
      county: companyDetails?.county || '',
      phoneNumber: companyDetails?.phoneNumber || '',
      mobileNumber: companyDetails?.mobileNumber || '',
      website: companyDetails?.website || '',
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      passwordRepeat: '',
      position: '',
      acceptTos: false,
      acceptNewsletter: true,
      cardholder: '',
      promoCode: '',
    }),
    [companyDetails, companyNumber, officialCompanyName],
  );

  const promptMessage = useMemo(
    () =>
      'Are you sure you want to leave this page? Any unsaved changes will be lost. Please confirm to proceed.',
    [],
  );
  usePrompt(step <= 3, promptMessage);

  return (
    <div className="register-final-page-container">
      <Formik initialValues={initialValues} enableReinitialize validateOnBlur validateOnChange>
        {({ values, setFieldValue }) => (
          <RegisterForm
            values={values}
            setFieldValue={setFieldValue}
            step={step}
            setStep={setStep}
          />
        )}
      </Formik>
    </div>
  );
}

export default RegisterPage;
